var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafariBrowser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a318k1npea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1486 0v950H0V0h1486z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "24qqb0p5db"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.954 0c8.258 0 14.953 6.447 14.953 14.4 0 7.952-6.695 14.399-14.953 14.399C6.695 28.799 0 22.352 0 14.399 0 6.447 6.695 0 14.954 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "iayqsb5pxc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.523 0c8.573 0 15.523 6.95 15.523 15.523 0 8.467-6.78 15.351-15.206 15.52l-.317.003C6.95 31.046 0 24.096 0 15.523 0 7.056 6.78.172 15.206.003L15.523 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "tcxml3p69e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.307 0c7.9 0 14.306 6.405 14.306 14.307 0 7.796-6.235 14.135-13.991 14.303l-.315.003C6.51 28.613.17 22.378.003 14.622L0 14.307C0 6.51 6.236.17 13.991.003L14.307 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m36b3nv2cg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.547 24.298c.116 0 .209.093.209.209v2.406a.208.208 0 1 1-.417 0v-2.406c0-.116.093-.209.208-.209zm1.28 1.314.021.001c.097.01.177.086.187.186l.105 1.007a.208.208 0 1 1-.415.043l-.105-1.006a.208.208 0 0 1 .228-.23zm-2.568 0h.022a.208.208 0 0 1 .185.23l-.106 1.006a.208.208 0 1 1-.415-.043l.106-1.007a.208.208 0 0 1 .23-.186zm3.554-1.551c.098-.001.185.066.206.165l.498 2.354a.208.208 0 1 1-.408.086l-.499-2.353a.208.208 0 0 1 .203-.252zm-4.539-.001a.208.208 0 0 1 .203.252l-.5 2.353a.208.208 0 1 1-.408-.087l.5-2.353a.208.208 0 0 1 .205-.166zm6.1 1.016a.208.208 0 0 1 .181.144l.313.962a.208.208 0 1 1-.397.129l-.313-.962a.208.208 0 0 1 .217-.273zm-7.655 0a.208.208 0 0 1 .216.273l-.313.962a.208.208 0 1 1-.397-.13l.313-.962a.208.208 0 0 1 .18-.143zm8.27-1.721a.208.208 0 0 1 .195.124l.977 2.198a.208.208 0 1 1-.381.17l-.977-2.199a.208.208 0 0 1 .187-.293zm-8.897-.006a.208.208 0 0 1 .186.294l-.98 2.196a.208.208 0 1 1-.38-.17l.98-2.197a.208.208 0 0 1 .194-.123zm10.633.679c.067.005.13.041.167.104l.506.876a.208.208 0 1 1-.362.209l-.506-.876a.208.208 0 0 1 .195-.313zm-12.356 0a.208.208 0 0 1 .195.313l-.505.876a.208.208 0 1 1-.362-.209l.506-.876c.037-.063.1-.1.166-.104zm12.599-1.815a.208.208 0 0 1 .176.086l1.412 1.947a.208.208 0 1 1-.337.245l-1.413-1.947a.208.208 0 0 1 .162-.331zm-12.852-.009a.208.208 0 0 1 .16.331l-1.415 1.946a.208.208 0 1 1-.337-.246L6.94 22.29a.208.208 0 0 1 .177-.086zm14.69.31a.208.208 0 0 1 .143.07l.677.751a.208.208 0 1 1-.31.28l-.677-.753a.208.208 0 0 1 .166-.348zm-16.518 0a.208.208 0 0 1 .166.348l-.677.751a.208.208 0 1 1-.31-.279l.677-.752a.209.209 0 0 1 .144-.069zm16.384-1.838a.208.208 0 0 1 .15.053l1.789 1.61a.208.208 0 1 1-.28.31l-1.788-1.61a.208.208 0 0 1 .129-.363zM5.418 20.67a.208.208 0 0 1 .128.364l-1.789 1.608a.208.208 0 1 1-.279-.31l1.79-1.608a.207.207 0 0 1 .15-.054zm18.11-.072c.04.002.08.015.115.04l.818.595a.208.208 0 1 1-.245.338l-.819-.595a.208.208 0 0 1 .13-.378zm-19.965-.007a.208.208 0 0 1 .13.378l-.82.594a.208.208 0 1 1-.245-.338l.82-.594a.209.209 0 0 1 .115-.04zm19.45-1.765a.207.207 0 0 1 .118.028l2.084 1.202a.208.208 0 1 1-.209.362l-2.083-1.203a.208.208 0 0 1 .09-.39zm-18.93 0a.208.208 0 0 1 .09.389l-2.084 1.203a.208.208 0 1 1-.209-.362l2.084-1.202a.207.207 0 0 1 .119-.028zm20.726-.452a.21.21 0 0 1 .081.018l.924.412c.106.047.153.17.106.276a.208.208 0 0 1-.275.105l-.925-.412a.208.208 0 0 1 .09-.4zm-22.527-.008a.208.208 0 0 1 .09.4l-.926.41a.208.208 0 1 1-.17-.38l.925-.412a.207.207 0 0 1 .081-.018zm21.696-1.621.042.009 2.287.745a.208.208 0 1 1-.13.397l-2.287-.745a.208.208 0 1 1 .13-.397zm-20.823-.008a.208.208 0 0 1 .047.406l-2.288.744a.208.208 0 1 1-.129-.397l2.288-.744a.201.201 0 0 1 .082-.01zm22.451-.821c.014 0 .028.001.042.004l.99.21a.208.208 0 1 1-.087.408l-.99-.21a.208.208 0 0 1 .045-.413zm-24.118-.003c.098 0 .185.067.206.166a.208.208 0 0 1-.161.247l-.99.21a.208.208 0 1 1-.087-.408l.99-.21a.212.212 0 0 1 .042-.005zm22.945-1.41.022.001 2.392.253a.208.208 0 1 1-.044.415l-2.392-.253a.208.208 0 1 1 .044-.415zM2.66 14.488l.021.001a.208.208 0 0 1 .001.416l-2.393.25a.208.208 0 1 1-.043-.416l2.393-.25a.193.193 0 0 1 .042 0zm-1.44-1.136a.208.208 0 1 1 0 .418H.21a.208.208 0 1 1 0-.418zm25.666 0a.208.208 0 1 1 0 .418h-1.012a.208.208 0 1 1 0-.418zm-.059-1.386.021.001a.208.208 0 0 1 .001.416l-2.393.25a.208.208 0 1 1-.043-.416l2.393-.25a.194.194 0 0 1 .042 0zM.27 11.95h.021l2.393.254a.208.208 0 1 1-.044.414l-2.392-.252a.208.208 0 1 1 .043-.415zm26.324-1.368a.208.208 0 0 1 .045.412l-.99.21a.208.208 0 1 1-.087-.407l.99-.21a.262.262 0 0 1 .042-.005zM.501 10.579c.014 0 .028.002.042.005l.99.21a.208.208 0 1 1-.086.408l-.99-.21a.208.208 0 0 1 .044-.413zm25.762-1.354a.208.208 0 0 1 .047.407l-2.288.744a.208.208 0 1 1-.13-.397l2.289-.744a.201.201 0 0 1 .082-.01zM.835 9.216a.21.21 0 0 1 .082.01l2.288.745a.208.208 0 1 1-.13.397L.788 9.623a.208.208 0 0 1 .047-.407zm24.894-1.289a.208.208 0 0 1 .09.4l-.925.41a.208.208 0 1 1-.17-.38l.924-.412a.21.21 0 0 1 .081-.018zM1.37 7.918c.028.001.055.007.081.019l.925.412a.208.208 0 1 1-.17.38l-.924-.411c-.106-.047-.153-.17-.106-.276a.208.208 0 0 1 .195-.124zm23.756-1.241a.208.208 0 0 1 .09.389l-2.084 1.203a.208.208 0 1 1-.208-.362l2.083-1.203a.207.207 0 0 1 .12-.027zm-23.155 0a.208.208 0 0 1 .119.027l2.083 1.203a.208.208 0 1 1-.208.362L1.88 7.066a.208.208 0 0 1 .09-.39zm22.367-1.158a.208.208 0 0 1 .13.378l-.82.594a.208.208 0 1 1-.244-.338l.819-.594a.208.208 0 0 1 .115-.04zM2.763 5.511c.04.002.08.015.116.04l.819.595a.208.208 0 1 1-.246.338l-.818-.595a.208.208 0 0 1 .13-.378zm20.725-1.085a.208.208 0 0 1 .128.364l-1.789 1.608a.208.208 0 1 1-.278-.31l1.789-1.608a.207.207 0 0 1 .15-.054zM3.613 4.42a.208.208 0 0 1 .15.054l1.789 1.61a.208.208 0 1 1-.28.31l-1.788-1.61a.208.208 0 0 1 .129-.364zM21.41 2.555a.208.208 0 0 1 .161.331l-1.415 1.946a.208.208 0 1 1-.338-.246l1.416-1.945a.208.208 0 0 1 .176-.086zM5.7 2.545a.208.208 0 0 1 .176.085L7.29 4.578a.208.208 0 1 1-.338.245L5.538 2.875a.208.208 0 0 1 .162-.33zm16.762.894a.208.208 0 0 1 .166.348l-.677.753a.208.208 0 1 1-.31-.28l.677-.752a.209.209 0 0 1 .144-.069zM4.634 3.438a.208.208 0 0 1 .145.069l.677.752a.208.208 0 1 1-.31.28l-.678-.753a.208.208 0 0 1 .166-.348zm14.357-2.28a.208.208 0 0 1 .187.294l-.98 2.197c-.048.106-.17.153-.276.106a.208.208 0 0 1-.106-.276l.98-2.197a.209.209 0 0 1 .195-.124zm-10.87-.007a.208.208 0 0 1 .194.124l.977 2.198a.208.208 0 1 1-.381.17l-.977-2.199a.208.208 0 0 1 .187-.293zm12.081.65a.208.208 0 0 1 .195.313l-.505.876a.208.208 0 1 1-.362-.209l.506-.876c.036-.063.1-.1.166-.104zm-13.31 0c.067.004.13.041.167.104l.506.876a.208.208 0 1 1-.362.209l-.506-.877a.208.208 0 0 1 .196-.312zM16.324.29a.208.208 0 0 1 .203.252l-.5 2.354a.208.208 0 1 1-.408-.087l.5-2.353a.208.208 0 0 1 .205-.165zM10.781.29c.097 0 .184.067.205.166l.499 2.354a.208.208 0 1 1-.409.086L10.578.541a.208.208 0 0 1 .203-.251zM13.547 0c.116 0 .209.093.209.209v2.406a.208.208 0 1 1-.417 0V.209c0-.116.093-.209.208-.209zm4.147.668.042.009c.11.036.17.153.134.263l-.313.962a.208.208 0 1 1-.397-.129l.313-.962a.208.208 0 0 1 .263-.134zM9.444.667a.208.208 0 0 1 .18.143l.312.963a.208.208 0 1 1-.396.129L9.227.939a.208.208 0 0 1 .216-.272zm5.498-.58h.022a.208.208 0 0 1 .186.23l-.106 1.006a.208.208 0 1 1-.415-.043l.106-1.007a.208.208 0 0 1 .229-.185zm-2.78-.002.02.001c.098.01.177.086.188.186l.105 1.007a.208.208 0 1 1-.415.043L11.955.316a.208.208 0 0 1 .228-.23z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "szjoxpr3qh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.628 0-8.072 10.171L0 17.99 7.215 6.63 18.628 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar2fm1bypi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.604 0 3.27 11.231 0 7.806 11.604 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gkwvpvi97j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.333 0 3.27 3.426L0 11.23 8.333 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "wzaza5xp0k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.968 0 1.636 1.713L0 9.519 9.968 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b5dxvqrkal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.968 0 1.636 11.231 0 9.52 9.968 0z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l55pup48pf",
    cx: 14.371,
    cy: 12.23,
    r: 15.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C5EC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BBF2",
    offset: "25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2F9",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08F",
    offset: "75%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080E7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hxba9g5lmd",
    x1: 15.523,
    y1: 31.046,
    x2: 15.523,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBDBD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a318k1npea)",
    transform: "translate(-405 -285)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#24qqb0p5db)",
    transform: "translate(405.968 287.795)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: "53%",
    d: "M0 0h29.907v28.799H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iayqsb5pxc)",
    transform: "translate(405.399 285.4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hxba9g5lmd)",
    d: "M0 0h31.046v31.046H0V0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.445 300.924c0 8.573-6.95 15.523-15.523 15.523h0c-8.574 0-15.523-6.95-15.523-15.523 0-8.574 6.95-15.524 15.523-15.524h0c8.573 0 15.523 6.95 15.523 15.524h0z",
    stroke: "#CDCDCD",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tcxml3p69e)",
    transform: "translate(406.615 286.617)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l55pup48pf)",
    d: "M0 0h28.613v28.613H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m36b3nv2cg)",
    transform: "translate(407.374 287.363)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F0F2",
    d: "M0 0h27.095v27.121H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#szjoxpr3qh)",
    transform: "translate(412.07 292.58)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: "40.9%",
    d: "M0 0h18.628v17.99H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ar2fm1bypi)",
    transform: "translate(419.286 291.405)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF3945",
    d: "M0 0h11.604v11.231H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gkwvpvi97j)",
    transform: "translate(410.953 299.21)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M0 0h11.604v11.231H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wzaza5xp0k)",
    transform: "translate(410.953 300.923)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B5B5B5",
    d: "M0 0h11.604v9.519H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b5dxvqrkal)",
    transform: "translate(420.922 291.405)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D42D35",
    d: "M0 0h9.968v11.231H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafariBrowser);
export default __webpack_public_path__ + "static/media/safari-browser.808b655715d67f7b1504bf9a48aa42b9.svg";
export { ForwardRef as ReactComponent };